import {Column, Entity, ManyToOne, PrimaryColumn, PrimaryGeneratedColumn} from "typeorm"
import { bigint } from "../../transofrmers/BigInt";
import { ContractTariff } from "./ContractTariff";

@Entity()
export class HistoricalTariffUsageMonthly {

	@PrimaryGeneratedColumn('increment')
	id!: number;
	
	@ManyToOne(() => ContractTariff, contract_tariff => contract_tariff.historical_monthly_usage, {onDelete: 'CASCADE', onUpdate:'CASCADE'})
  contract_tariff?: ContractTariff;

	@Column('datetime')
	timestamp!: Date;

	@Column({ type: "bigint", transformer:bigint })
	usage_data!: number;

	@Column({ type: "bigint", transformer:bigint })
	usage_voice!: number;

	@Column({ type: "bigint", transformer:bigint })
	usage_sms!: number;
}